import { render, staticRenderFns } from "./quotationadmin.vue?vue&type=template&id=615ae341&scoped=true&"
import script from "./quotationadmin.vue?vue&type=script&lang=js&"
export * from "./quotationadmin.vue?vue&type=script&lang=js&"
import style0 from "./quotationadmin.vue?vue&type=style&index=0&id=615ae341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ae341",
  null
  
)

export default component.exports